<section class="trainer-page">
  <div class="wrap">

    <div class="greeting">
      <div class="greeting-row">
        <div class="greeting-text">
          <h2>{{ 'TRAINING_PREPARE.GREETING' | translate:{ name: currentUser?.displayName } }}</h2>
          <p>{{ 'TRAINING_PREPARE.GREETING_SUBTEXT' | translate }}</p>
        </div>
        <div class="month-stat" *ngIf="routerUrl === '/training-screen' && currentUser?.monthSessions">
          <span class="material-symbols-outlined">calendar_month</span>
          <div class="month-stat-text">
            <div class="month-label">{{ 'TRAINING_PREPARE.LEFT_PER_MONTH' | translate }}</div>
            <div class="month-figure mono">{{ convertMonthTime(currentUser?.monthSessions.monthTimeLeft) }}</div>
          </div>
        </div>
      </div>
    </div>

    <section aria-labelledby="status-heading" tourAnchor="prepare-tour">
      <div class="section-head">
        <h3 id="status-heading">{{ 'TRAINING_PREPARE.HEADING' | translate }}</h3>
      </div>
      <div class="status-card">
        <div class="status-item" [ngClass]="isSensorConnected ? 'is-good' : 'is-bad'">
          <div class="status-icon"><span class="material-symbols-outlined">{{ isSensorConnected ? 'bluetooth' : 'bluetooth_disabled' }}</span></div>
          <div class="status-body">
            <div class="status-label">{{ 'TRAINING_PREPARE.CONNECTION' | translate }}</div>
            <span class="status-pill" [ngClass]="isSensorConnected ? 'good' : 'bad'">
              <span class="material-symbols-outlined">{{ isSensorConnected ? 'check_circle' : 'cancel' }}</span>
              {{ (isSensorConnected ? 'TRAINING_PREPARE.CONNECTED' : 'TRAINING_PREPARE.NOT_CONNECTED') | translate }}
            </span>
          </div>
        </div>
        <div class="status-item" [ngClass]="currentImpedance && currentImpedance < 20 ? 'is-good' : 'is-bad'">
          <div class="status-icon"><span class="material-symbols-outlined">vital_signs</span></div>
          <div class="status-body">
            <div class="status-label">
              {{ 'TRAINING_PREPARE.IMPEDANCE' | translate }}
              <button (click)="openInfoDialogImpedance()" class="info-btn-inline" type="button" [attr.aria-label]="'TRAINING_PREPARE.IMPEDANCE' | translate">
                <span class="material-symbols-outlined">info</span>
              </button>
            </div>
            <div class="status-value mono" *ngIf="currentImpedance">{{ currentImpedance }} kΩ</div>
            <div class="status-value mono" *ngIf="!currentImpedance">—</div>
            <span class="status-pill" *ngIf="currentImpedance" [ngClass]="currentImpedance < 20 ? 'good' : 'bad'">
              <span class="material-symbols-outlined">{{ currentImpedance < 20 ? 'check_circle' : 'cancel' }}</span>
              {{ (currentImpedance < 20 ? 'TRAINING_PREPARE.GOOD_CONTACT' : 'TRAINING_PREPARE.CONTACT_ISSUE') | translate }}
            </span>
          </div>
        </div>
        <div class="status-item" [ngClass]="currentArtefakt && currentArtefakt < 6 ? 'is-good' : 'is-bad'">
          <div class="status-icon"><span class="material-symbols-outlined">monitor_heart</span></div>
          <div class="status-body">
            <div class="status-label">
              {{ 'TRAINING_PREPARE.MUSCLE' | translate }}
              <button (click)="openInfoDialogArtefact()" class="info-btn-inline" type="button" [attr.aria-label]="'TRAINING_PREPARE.MUSCLE' | translate">
                <span class="material-symbols-outlined">info</span>
              </button>
            </div>
            <div class="status-value mono" *ngIf="currentArtefakt">{{ currentArtefakt }} µV</div>
            <div class="status-value mono" *ngIf="!currentArtefakt">—</div>
            <span class="status-pill" *ngIf="currentArtefakt" [ngClass]="currentArtefakt < 6 ? 'good' : 'bad'">
              <span class="material-symbols-outlined">{{ currentArtefakt < 6 ? 'check_circle' : 'cancel' }}</span>
              {{ (currentArtefakt < 6 ? 'TRAINING_PREPARE.CLEAN_SIGNAL' : 'TRAINING_PREPARE.SIGNAL_ISSUE') | translate }}
            </span>
          </div>
        </div>
      </div>
      <div class="inline-warning" *ngIf="(currentArtefakt > 6 || currentImpedance > 20) && !isDemoMode">
        <span class="material-symbols-outlined">warning</span>
        <p>{{ 'TRAINING_PREPARE.WARNING' | translate }}</p>
      </div>
    </section>

    <ng-container *ngIf="routerUrl === '/training-screen'">
      <section *ngIf="(currentArtefakt && currentArtefakt < 6 && currentImpedance && currentImpedance < 20) || isDemoMode" aria-labelledby="templates-heading">
        <div class="supervisor-training-route" *ngIf="currentUser?.role !== 'normal' && currentUser?.role !== 'premium'">
          <button mat-raised-button color="primary" (click)="toTraining(undefined)">{{'TRAINING_PREPARE.TO_TRAINING' | translate}}</button>
        </div>

        <div class="section-head">
          <h3 id="templates-heading">
            <ng-container *ngIf="routerUrl === '/training-screen' && !isSupervisorTemplate(userSurveyTrainings)">{{'TRAINING_PREPARE.SELECT_TRAINING' | translate}}</ng-container>
            <ng-container *ngIf="routerUrl === '/training-screen' && isSupervisorTemplate(userSurveyTrainings) && currentUser?.role === 'normal'">{{'TRAINING_PREPARE.CUSTOM_TRAINING' | translate}}</ng-container>
            <ng-container *ngIf="routerUrl === '/test' && currentUser?.role === 'normal'">{{'TRAINING_PREPARE.SELECT_TEST' | translate}}</ng-container>
          </h3>
          <div class="hint">{{ 'TRAINING_PREPARE.TEMPLATES_AVAILABLE' | translate:{ count: sortedTrainings.length } }}</div>
        </div>

        <p class="empty-state" *ngIf="!sortedTrainings.length">{{ 'TRAINING_PREPARE.NO_TEMPLATES' | translate }}</p>

        <div class="template-groups" [ngClass]="{'template-groups-limited' : !currentUser?.monthSessions.catStartSession}">
          <div class="grid">
            <div class="card" #cardEl *ngFor="let item of sortedTrainings"
                 [ngClass]="{'selected': item === effectiveSelection}"
                 (click)="selectTraining(item)">
              <div class="card-top">
                <button class="info-btn" type="button" (click)="toggleExpand(item); $event.stopPropagation()">
                  <span class="material-symbols-outlined">info</span>
                </button>
              </div>
              <div class="card-title-row">
                <p class="card-title">{{item | templateTranslate}}</p>
              </div>
              <p class="card-sub" *ngIf="item.data?.length">{{ 'TRAINING_PREPARE.PARTS' | translate:{ count: item.data.length, minutes: getTemplateDuration(item) } }}</p>

              <div class="card-meta">
                <div class="card-creator" *ngIf="item.supervisorName || currentUser?.displayName">
                  <span class="material-symbols-outlined">person</span>
                  <span>{{ item.supervisorName || currentUser?.displayName }}</span>
                </div>
                <div class="creation-time">
                  <span class="material-symbols-outlined">calendar_month</span>
                  <span>{{transformDate(item.id)}}</span>
                </div>
              </div>

              <div class="info-list" [@detailExpand]="item === expandedTemplate ? 'expanded' : 'collapsed'">
                <div class="info-item" *ngFor="let info of item.data; let i = index">
                  <ng-container *ngIf="info.checked">
                    <span>{{i + 1}})</span>
                    <span>{{info.trainingProtocol | titlecase}}</span>
                    <span *ngIf="info.trainingProtocol === 'amplitude'">
                    {{getRatioName(info?.frequencyOne) | uppercase}}
                  </span>
                    <span *ngIf="info.trainingProtocol === 'ratio'">
                    {{getRatioName(info?.frequencyOne) | uppercase}} / {{getRatioName(info?.frequencyTwo) | uppercase}}
                  </span>
                    <span>{{getThresholdTranslate(info?.threshHoldType)}}</span>
                    <span>, {{info.length}} min.</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sessions-note" *ngIf="routerUrl === '/training-screen'">
          <p *ngIf="currentUser?.monthSessions.dayLimitReached && currentUser?.monthSessions.monthTimeLeft !== 0">{{'TRAINING_PREPARE.NEXT_SESSION_AVAILABLE' | translate}} <span class="limit-value">{{convertHoursToHHMM(currentUser?.monthSessions.nextSessionAvailableInHours)}}</span></p>
          <p *ngIf="currentUser?.monthSessions.monthTimeLeft <= 0">{{'TRAINING_PREPARE.LIMIT_REACHED' | translate}}</p>
        </div>

      </section>
    </ng-container>

    <div class="footer-bar" #footerBar *ngIf="effectiveSelection">
      <div class="footer-inner">
        <div class="footer-left">
          <div class="footer-icon"><span class="material-symbols-outlined">psychology</span></div>
          <div class="footer-text">
            <div class="footer-label">{{ 'TRAINING_PREPARE.SELECTED_TEMPLATE' | translate }}</div>
            <div class="footer-title">{{ effectiveSelection | templateTranslate }}</div>
          </div>
        </div>
        <div class="footer-warn" *ngIf="!isSensorConnected && !isDemoMode">
          <span class="material-symbols-outlined">cancel</span>
          {{ 'TRAINING_PREPARE.CONNECT_TO_START' | translate }}
        </div>
        <div class="footer-right">
          <button class="start-btn" type="button" [disabled]="!isSensorConnected && !isDemoMode" (click)="toTraining(effectiveSelection)">
            <span class="material-symbols-outlined">play_arrow</span>
            {{ 'TRAINING_PREPARE.START_TRAINING' | translate }}
          </button>
          <button class="footer-close" type="button" (click)="clearSelection()" [attr.aria-label]="'TRAINING_PREPARE.CLEAR_SELECTION' | translate">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</section>
